import React, { useState, useEffect } from 'react';
import { ItemListWrapper, Item } from './ToggleList.styled';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';

const StyledSwitch = styled(Switch)(({col}) => ({
  width: 62,
  height: 20,
  padding: 6,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    transform: 'translateX(6px)',
    '& + .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: 'rgba(221, 221, 221, 1)',
    },
    '&.Mui-checked': {
      color: 'red',
      transform: 'translateX(40px)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: col ? col : '#0d736357',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    // backgroundColor: '#353CF7',
    backgroundColor: col ? col :  'var(--Headlines, rgba(42, 136, 107, 1))',

  },
}));

const ItemList = ({ exclusion = false, items, setData = () => { } }) => {
  const [toggleList, setToggle] = useState(items);
  
    const { personalDetailsData } = useSelector((state) => state.tenantSetting);

  const handleToggle = (toggleIndex) => {
    items[toggleIndex].isActive = !items[toggleIndex].isActive;
    setToggle([...items]);
  };

  useEffect(() => {
    setData(toggleList);
  }, [toggleList]);

  return (
    <ItemListWrapper exclusion={exclusion}>
      {toggleList.map((item, index) => (
        <Item exclusion={exclusion} key={item.id}>
          <span>{item.name}</span>
          <StyledSwitch
            col={personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'#0d736357'}
            checked={item.isActive}
            onClick={() => handleToggle(index)}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </Item>
      ))}
    </ItemListWrapper>
  );
};

export default ItemList;
